import AddIcon from "@/components/icons/AddIcon";
import CurrencyIcon from "@/components/icons/CurrencyIcon";
import MinusIcon from "@/components/icons/MinusIcon";
import { useState } from "react";

const BundleExtraPricesCart = ({
  product,
  selectedProducts,
  setSelectedProducts,
  t,
}) => {
  const price = Number(product?.prices_with_tax?.discounted_price);
  const original_price = Number(product?.prices_with_tax?.original_price);
  const [qty, setQty] = useState(1);
  const isSelected = selectedProducts
    ?.map((i) => i?.sku)
    .includes(product?.sku);
  function addItemToBundle(product, qty) {
    if (isSelected) {
      setSelectedProducts((prev) =>
        prev?.map((item) =>
          item?.sku == product?.sku ? { ...item, qty: qty } : item
        )
      );
    } else {
      setSelectedProducts((prev) => [...prev, { ...product, qty }]);
    }
  }

  function removeItemFromBundle(product) {
    setSelectedProducts((prev) => prev?.filter((p) => p?.sku !== product?.sku));
  }

  return (
    <div className="flex gap-4 justify-between max-sm:justify-between max-sm:max-w-[90%]">
      <div className="flex flex-col w-full gap-1 max-sm:hidden">
        <div className="justify-between max-sm:flex">
          <p className="flex items-center gap-2 max-sm:text-sm">
            <span className="max-sm:hidden">{t("Price")} :</span>
            <span className="flex items-center gap-1 text-gray-500 line-through">
              {original_price} <CurrencyIcon className="size-3.5" />
            </span>
          </p>
          <p className="flex items-center gap-2 max-sm:text-sm">
            <span className="max-sm:hidden">{t("Saving")} :</span>
            <span className="flex items-center gap-1 font-bold text-red-600">
              {t("Save money")} {product?.prices_with_tax?.discount_amount}{" "}
              <CurrencyIcon className="size-3.5" />
            </span>
          </p>
        </div>
        <p className="flex items-center gap-2 max-sm:text-sm">
          <span className="max-sm:hidden">{t("Final Price")} :</span>
          <span className="flex items-center gap-1 font-bold max-sm:text-secondary-900">
            {price} <CurrencyIcon className="size-3.5" />
          </span>
        </p>
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex items-center max-sm:hidden">
          <button
            onClick={() => setQty(qty - 1)}
            disabled={qty == 1}
            className="size-9 max-sm:size-7 grid place-items-center bg-[#EAE8E880]"
          >
            <MinusIcon />
          </button>
          <span className="grid flex-1 max-sm:flex max-sm:justify-center border-y h-9 w-14 max-sm:h-7 max-sm:w-8 place-items-center">
            {qty}
          </span>
          <button
            onClick={() => setQty(qty + 1)}
            className="size-9 max-sm:size-7 grid place-items-center bg-[#EAE8E880]"
          >
            <AddIcon />
          </button>
        </div>
        <button
          onClick={() => {
            isSelected
              ? removeItemFromBundle(product)
              : addItemToBundle(product, qty);
          }}
          className={`min-md:w-full max-sm:hidden max-sm:col-span-full p-2 max-sm:px-4 max-sm:py-1 text-sm text-white ${
            isSelected ? "bg-red-600" : "bg-primary"
          } rounded-md`}
        >
          {isSelected ? t("Remove item") : t("Add item")}
        </button>
      </div>
    </div>
  );
};

export default BundleExtraPricesCart;
